import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "../insta/instagram.module.scss";

export class instagram extends Component {
  static propTypes = {};

  render() {
    const websiteInfo = [
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/5467ins.png",
        name: "Instagram Business Pack",
        pra: "NO. OF REACH 500000 PEOPLE",
        infoList: [
          {
            list: " Instagram Page Optimization",
          },
          {
            list: " Instagram Reach People ( 350000 - 500000 Reach )",
          },
          {
            list: " Additional Followers 100 Nos",
          },
          {
            list: " Alternative Day Instagram Posts ( 8 Nos. )",
          },
          {
            list: " Instagram Cover Design",
          },
          {
            list: " Instagram DP Design",
          },
          {
            list: " Instagram Goal Ad Setup.",
          },
          {
            list: " Instagram Ads Manager Setup",
          },
          {
            list: " Visitor Analysis",
          },
        ],
        del: "Delivery in :",
        day: "30 day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/15951867277608185.png",
        name: "Instagram Follower Standard",
        pra: "NO. OF FOLLOWERS 5000",
        infoList: [
          {
            list: " Instagram Page Optimization",
          },
          {
            list: " Instagram Followers ( 5000 Nos )",
          },
          {
            list: " Facebook Page Integration",
          },
          {
            list: " Alternative Day Instagram Posts ( 8 Nos. )",
          },
          {
            list: " Instagram DP Design",
          },
          {
            list: " Instagram Goal Ad Setup",
          },
          {
            list: " Instagram Ads Manager Setup",
          },
          {
            list: " Conversion Rate Optimization",
          },
          {
            list: " Setup & Tracking/Monitoring",
          },
        ],
        del: "Delivery in :",
        day: "30 day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
    ];

    return (
      <div>
        <section className={styles.website}>
          {websiteInfo.map((web) => {
            return (
              <div>
                <div className={styles.wrap}>
                  <div className={styles.imgs}>
                    <img src={web.url} alt="" />
                  </div>
                  <div className={styles.info}>
                    <h2>
                      <Link
                        href="online-product/nano-website-design"
                        class="th-color"
                      >
                        {web.name}
                      </Link>
                    </h2>
                    <p>{web.pra}</p>
                    <ul>
                      {web.infoList.map((weblist) => {
                        return <li>{weblist.list}</li>;
                      })}
                    </ul>
                  </div>
                  <div className={styles.btn_grp}>
                    <h3>
                      {web.del} <span>{web.day}</span>{" "}
                    </h3>
                    <button>{web.butonOne}</button>
                    <button>{web.buttonTwo}</button>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
        <section className={styles.website_mobile}>
          <div className="container">
            <div className={styles.back_button}>
              <Link to="/service">
                <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
              </Link>
            </div>
            {websiteInfo.map((web) => {
              return (
                <div>
                  <div className={styles.wrap}>
                    <div className={styles.imgs}>
                      <img src={web.url} alt="" />
                    </div>
                    <div className={styles.info}>
                      <h2>
                        <Link
                          href="online-product/nano-website-design"
                          class="th-color"
                        >
                          {web.name}
                        </Link>
                      </h2>
                      <p>{web.pra}</p>
                      <div className={styles.btn_grp}>
                        <h3>
                          {web.del} <span>{web.day}</span>{" "}
                        </h3>
                        <button>{web.butonOne}</button>
                        <button>{web.buttonTwo}</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    );
  }
}

export default instagram;
